module.exports = __webpack_public_path__ + "img/navbar_logo.a1bc46e3.png";